require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuung-10-14-sonderschule-anteil-nachmittagsbetreuung.json") })
        }
      }, "path---betreuung-10-14-sonderschule-anteil-nachmittagsbetreuung");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuung-10-14-sonderschule-anteil-nachmittagsbetreuung!./.cache/json/betreuung-10-14-sonderschule-anteil-nachmittagsbetreuung.json
// module id = 851
// module chunks = 231608221292675